import api from '../../../api';

export const insertInvoice = params => api.post('Invoice/InsertInvoice', {
  RequestWrapper: {
    workflowId: params.workflowId,
    companyId: params.companyId,
    userId: params.userId,
    codeBar: params.codeBar,
    invoiceNumber: params.invoiceNumber,
    expiration: params.expiration,
  },
}).then(response => response.data);

export const searchInvoice = params => api.get('Invoice', {
  params: {
    invoicenumber: params.invoiceNumber,
    companyId: params.companyId,
  },
}).then(response => response.data.return);

export const getAllInvoices = params => api.get('Invoice/AllInvoices', {
  params: {
    companyid: params.companyid,
    holdingid: params.holdingId,
  },
}).then(response => response.data.return);

export const insertInvoiceLot = params => api.post('Invoice/InsertInvoiceLot', {
  RequestWrapper: {
    workflowId: params.workflowId,
    companyId: params.companyId,
    userId: params.userId,
    expiration: params.expiration,
    files: params.files,
  },
}).then(response => response.data);



// WEBPACK FOOTER //
// ./src/redux/actions/tracker/invoiceActions.js